import { useDisclosure } from "@heroui/modal";

function useConfirmAlert() {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return { isOpen, onOpen, onClose };
}

export default useConfirmAlert;
